import { FC, useState } from 'react';
import { Modal } from 'components';
import SectionStyled, { ContentStyled } from './styles';

const ConfirmDelete: FC = () => {
  const [visible, setVisible] = useState<boolean>(false);

  const okButton = {
    text: '削除',
    onClick: () => setVisible(false),
  };
  const cancelButton = {
    text: 'キャンセル',
    onClick: () => setVisible(false),
  };

  return (
    <SectionStyled>
      <button onClick={() => setVisible(true)}>Open modal ConfirmDelete</button>
      <Modal
        title="この項目を削除します。よろしいですか？"
        visible={visible}
        width={640}
        okButton={okButton}
        cancelButton={cancelButton}
      >
        <ContentStyled>この操作は元に戻せません</ContentStyled>
      </Modal>
    </SectionStyled>
  );
};

export default ConfirmDelete;
